
import React from "react";
import { DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CreatePixelForm, PixelFormValues } from "../CreatePixelForm";

interface CreatePixelContentProps {
  onSubmit: (data: PixelFormValues) => Promise<void>;
  isSubmitting: boolean;
}

export function CreatePixelContent({ onSubmit, isSubmitting }: CreatePixelContentProps) {
  // Using useCallback to ensure consistent function reference
  const handleSubmit = React.useCallback(
    async (data: PixelFormValues) => {
      if (isSubmitting) {
        console.log("Preventing multiple submissions while submitting");
        return; // Prevent multiple submissions
      }
      console.log("CreatePixelContent: Submitting form data", data);
      try {
        await onSubmit(data);
      } catch (error) {
        console.error("Error in CreatePixelContent submit handler:", error);
      }
    },
    [onSubmit, isSubmitting]
  );

  return (
    <>
      <DialogHeader>
        <DialogTitle>Create New Pixel</DialogTitle>
        <DialogDescription>
          Create a new pixel to track visitors on your website.
        </DialogDescription>
      </DialogHeader>
      <CreatePixelForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
    </>
  );
}
